import { render, staticRenderFns } from "./tem.vue?vue&type=template&id=17b71e28&scoped=true&"
import script from "./tem.vue?vue&type=script&lang=js&"
export * from "./tem.vue?vue&type=script&lang=js&"
import style0 from "./tem.vue?vue&type=style&index=0&id=17b71e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b71e28",
  null
  
)

export default component.exports